// extracted by css-extract-rspack-plugin
export default {"files-pagination":"FilesPagination_files-pagination__iDQqw"};